import { message } from 'antd';
import createClient from '../../apolloClient';
import MUTATION_CHANGE_PASSWORD from '../../mutation/changePassword';

const handleChangePassword = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_CHANGE_PASSWORD,
    variables,
  });
  const { changePassword } = result?.data || {};
  return changePassword;
};

export default handleChangePassword;
